module.exports={
  "name": "react-starterify",
  "version": "2.4.1",
  "description": "React JS application skeleton using Browserify and other awesome tools",
  "main": "app.js",
  "repository": {
    "type": "git",
    "url": "https://github.com/Granze/react-starterify"
  },
  "keywords": [
    "gulp",
    "react",
    "browserify",
    "seed",
    "boilerplate",
    "kickstarter",
    "ES6",
    "ES2015",
    "babel",
    "ava"
  ],
  "ava": {
    "require": [
      "babel-register"
    ],
    "babel": "inherit"
  },
  "scripts": {
    "start": "npm run watch",
    "watch": "gulp watch",
    "build": "gulp build",
    "deploy": "gulp deploy",
    "test": "ava --tap | tap-nyan"
  },
  "author": "Maurizio Mangione",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/Granze/react-starterify/issues"
  },
  "homepage": "https://github.com/Granze/react-starterify",
  "dependencies": {
    "googleapis": "^8.0.0",
    "history": "^2.0.0",
    "postcss-for": "^2.0.3",
    "react": "^15.0.0",
    "react-dom": "^15.0.0",
    "react-router": "^2.0.0",
    "superagent": "^2.0.0",
    "swearjar": "^0.1.3"
  },
  "devDependencies": {
    "autoprefixer": "^6.0.0",
    "ava": "^0.14.0",
    "babel": "^6.5.2",
    "babel-core": "^6.3.17",
    "babel-eslint": "^6.0.0",
    "babel-preset-es2015": "^6.3.13",
    "babel-preset-react": "^6.3.13",
    "babel-register": "^6.6.5",
    "babelify": "^7.2.0",
    "browser-sync": "^2.9.1",
    "browserify": "^13.0.0",
    "cssnano": "^3.0.0",
    "eslint": "^2.3.0",
    "eslint-config-airbnb": "^6.1.0",
    "eslint-plugin-react": "^4.2.1",
    "gulp": "^3.9.0",
    "gulp-eslint": "^2.0.0",
    "gulp-gh-pages": "^0.5.4",
    "gulp-html-replace": "^1.5.1",
    "gulp-imagemin": "^2.4.0",
    "gulp-notify": "^2.2.0",
    "gulp-postcss": "^6.0.0",
    "gulp-rename": "^1.2.2",
    "gulp-sourcemaps": "^1.5.2",
    "gulp-uglify": "^1.4.0",
    "imagemin-pngquant": "^4.2.0",
    "lodash": "^4.6.0",
    "postcss-calc": "^5.2.1",
    "postcss-math": "0.0.1",
    "postcss-nested": "^1.0.0",
    "postcss-simple-extend": "^1.0.0",
    "postcss-simple-vars": "^1.0.0",
    "react-addons-test-utils": "^15.0.0",
    "rimraf": "^2.4.3",
    "run-sequence": "^1.1.2",
    "tap-nyan": "0.0.2",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^1.1.0",
    "watchify": "^3.4.0"
  }
}
